import { Toast } from 'primereact/toast';
import { type PropsWithChildren, useMemo, useRef } from 'react';

import { FeedbackContext, type FeedbackContextValue } from './feedback';

export function FeedbackProvider({ children }: PropsWithChildren) {
  const toastRef = useRef<Toast>(null);
  const value = useMemo<FeedbackContextValue>(
    () => ({
      showInfo: (summary, detail) =>
        toastRef.current?.show({ severity: 'info', summary, detail, life: 4500 }),
      showSuccess: (summary, detail) =>
        toastRef.current?.show({ severity: 'success', summary, detail, life: 4500 }),
      showError: (summary, detail) =>
        toastRef.current?.show({ severity: 'error', summary, detail, life: 6500 }),
    }),
    [],
  );

  return (
    <FeedbackContext.Provider value={value}>
      {children}
      <Toast ref={toastRef} />
    </FeedbackContext.Provider>
  );
}
